type TenantOrganizationLike = {
  id?: string;
  name?: string;
};

type UserLike = {
  id?: string;
  name?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  organization?: { id?: string | null } | null;
  tenantOrganization?: TenantOrganizationLike | null;
};

export function getStudentOrg(user: UserLike | null | undefined) {
  return {
    organizationName: user?.tenantOrganization?.name ?? "",
    organizationId: user?.tenantOrganization?.id ?? user?.organization?.id ?? "",
  };
}

export function buildCourseEnrollmentPayload(user: UserLike | null | undefined, courseId: string) {
  const studentName =
    user?.name ||
    [user?.firstName, user?.lastName].filter(Boolean).join(" ").trim() ||
    user?.email ||
    "";
  const org = getStudentOrg(user);

  return {
    studentId: user?.id ?? "",
    courseId,
    studentName,
    studentEmail: user?.email ?? "",
    organizationName: org.organizationName,
    organizationId: org.organizationId,
  };
}
